import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { useSelector } from 'react-redux';
import { IReduxState } from 'app/store';
import { LoginService } from 'login/services/login.service';

export function KeyDomainsActionsDropdown(props: any) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { user } = useSelector((state: IReduxState) => state.login);

  const isDisabled = (): boolean => {
    if (LoginService.isViewer(user)) {
      return true;
    }
    return false;
  };

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isDisabled()) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteAndBlacklistClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (isDisabled()) {
      return;
    }
    const assetName = props.params.row.asset;
    if (props.onDeletePopup) {
      props.onDeletePopup([assetName], 'delete-and-blacklist');
    }
    setAnchorEl(null);
  };

  const handleDeleteAndRetainClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (isDisabled()) {
      return;
    }
    const assetName = props.params.row.asset;
    if (props.onDeletePopup) {
      props.onDeletePopup([assetName], 'delete-and-retain');
    }
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOnClick}
        disabled={isDisabled()}
        sx={{
          color: isDisabled() ? '#ccc' : '#5D6576',
          '&:hover': {
            backgroundColor: isDisabled() ? 'transparent' : '#f6f8ff'
          }
        }}
      >
        <img
          src="/assets/images/trash.svg"
          alt="delete asset"
          style={{
            opacity: isDisabled() ? 0.3 : 1,
            width: '16px',
            height: '16px'
          }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          sx: {
            minWidth: 160,
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
            border: '1px solid #ecedff'
          }
        }}
      >
        <MenuItem
          onClick={handleDeleteAndBlacklistClick}
          disabled={isDisabled()}
          sx={{
            fontSize: '13px',
            color: isDisabled() ? '#ccc' : '#5D6576',
            '&:hover': {
              backgroundColor: isDisabled() ? 'transparent' : '#f6f8ff'
            }
          }}
        >
          <ListItemText primary="Delete and Blacklist" />
        </MenuItem>
        <MenuItem
          onClick={handleDeleteAndRetainClick}
          disabled={isDisabled()}
          sx={{
            fontSize: '13px',
            color: isDisabled() ? '#ccc' : '#5D6576',
            '&:hover': {
              backgroundColor: isDisabled() ? 'transparent' : '#f6f8ff'
            }
          }}
        >
          <ListItemText primary="Delete and Retain" />
        </MenuItem>
      </Menu>
    </>
  );
}
